import React from "react";
import { BringToFront, SendToBack } from "lucide-react";
import { bringElement } from "../../../lib/shapes";

const iconsObjects = [
  {
    key: "forward",
    component: BringToFront,
    title: "Bring Forward",
  },
  {
    key: "backward",
    component: SendToBack,
    title: "Send Backward",
  },
  {
    key: "front",
    component: BringToFront,
    title: "Bring To Front",
  },

  {
    key: "back",
    component: SendToBack,
    title: "Send To Back",
  },
];

const LayeringControl = ({
  fabricRef,
  reorderCanvasObjects,
  saveStateToHistory,
}: any) => {
  return (
    <section className="flex flex-col border-b border-borderColor">
      <div className="px-2 py-5">
        <div className="mb-2">
          <h3 className="text-[10px] uppercase px-1">Layering</h3>
        </div>

        <div className="flex flex-row items-center justify-between gap-1">
          {iconsObjects.map((icon) => (
            <div
              key={icon.key}
              title={icon.title}
              className="p-1 rounded hover:bg-black group relative"
              onClick={() => {
                bringElement({
                  canvas: fabricRef.current,
                  direction: icon.key,
                  reorderCanvasObjects,
                  saveStateToHistory,
                });
              }}
            >
              <icon.component
                size={20}
                className="text-body group-hover:cursor-pointer group-hover:text-primary"
              />

              {(icon.key === "forward" || icon.key === "backward") && (
                <div className=" absolute -top-1 -right-1">
                  <p className="text-xs text-center text-primary font-bold">
                    1
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LayeringControl;
